import React from "react";
import PropTypes from "prop-types";
import { Modal, Col, Input, Row, message, List, Icon, Divider, Button } from "antd";
import { DBOnBoardingService } from "../../services";

class ProceedAndReferActionModal extends React.Component {

    state = {
        remarks: ''
    }

    onChangeRemarks = (e) => {
        this.setState({
            remarks: e.target.value
        });
    }

    onSubmit = () => {
        if (this.state.remarks) {
            this.props.onProceed(this.state.remarks)
        } else {
            message.error("Please add remarks to proceed")
        }
    }

    render() {
        const { modalVisible, referOrProceedStageName } = this.props;
        return (
            <Modal
                title={this.props.referback ? "Refer Back" : 'Proceed'}
                visible={modalVisible}
                destroyOnClose={true}
                onCancel={this.props.closeModal}
                footer={
                    this.props.pendency.size  ? (
                        <Button key="cancel" onClick={() => this.props.closeModal()}>
                            Cancel
                        </Button>
                    ) : [
                        <Button key="cancel" onClick={() => this.props.closeModal()}>
                            Cancel
                        </Button>,
                        <Button key="ok" disabled={this.props.loadingBtn} type="primary" onClick={() => this.onSubmit()}>
                            OK
                        </Button>
                    ]
                }
                closable
                maskClosable
            >
                <Row>
                    {!this.props.pendency.size || this.props.referback ? <><React.Fragment>
                        <p>* All the fields are mandatory</p>
                        <Col span={12} className={"px-5"}>
                        </Col>
                    </React.Fragment>
                        <Col span={24} className={"p-5"}>
                            <Input.TextArea required placeholder={"Remarks"} onChange={this.onChangeRemarks} autosize={{ minRows: 2, maxRows: 3 }} />
                        </Col></> : 
                        <Col span="24">
                            <List>
                                {this.props.pendency
                                    .map((_, key) => (
                                        <List.Item key={key}>
                                            <List.Item.Meta
                                                title={_}
                                            />
                                            <Icon
                                                type={
                                                    "check-circle"
                                                }
                                                theme={"filled"}
                                                style={{
                                                    fontSize: "18px",
                                                    color: "#ccc"
                                                }}
                                            />
                                        </List.Item>
                                    ))}
                            </List>
                        </Col>}
                </Row>
            </Modal>
        );
    }
}

ProceedAndReferActionModal.propTypes = {
    modalVisible: PropTypes.bool,
    closeModal: PropTypes.func,
    referback: PropTypes.string,
    referOrProceedStageName: PropTypes.String,
    pendency: PropTypes.array,
};

export default ProceedAndReferActionModal;
